/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useMutation } from '@apollo/client';
import { Button, Flex, useDisclosure, useToast, WrapItem } from '@chakra-ui/react';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadAndViewButton from '../../../components/Files/DownloadAndViewButton';
import useStore from '../../../store';
import DoneFileModal from './DoneFileModal';

const M_REMOVE = gql`
	mutation removeNpDoneFile($npId: String!) {
		removeNpDoneFile(npId: $npId) {
			id
		}
	}
`;

function DoneFile({ npId = null, doneFile = null, onCallback = () => null }) {
	const toast = useToast();
	const modal = useDisclosure();
	const { t } = useTranslation();
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const [isPermitted, setPermitted] = useState(false);
	const [removeFile] = useMutation(M_REMOVE);

	useEffect(() => {
		if (user) {
			const roles = user?.role.split(',') || [];
			setPermitted(roles?.includes('admin') || roles?.includes('assistant'));
		}
	}, [user]);

	return (
		<>
			<Flex justifyContent="flex-start" alignItems="center">
				<>
					{doneFile?.file ? (
						<>
							<WrapItem className="avatarWraper">
								{isPermitted && (
									<FontAwesomeIcon
										onMouseDown={() => {
											removeFile({ variables: { npId } })
												.then(({ data }) => {
													onCallback();
												})
												.catch((error) => {
													if (error?.graphQLErrors?.length > 0) {
														error?.graphQLErrors.map(({ message }, i) =>
															toast({
																title: t(message),
																status: 'error',
																isClosable: true,
																position: 'bottom-right',
															}),
														);
													} else {
														toast({
															title: t(error?.message ? error?.message : 'something went wrong'),
															status: 'error',
															isClosable: true,
															position: 'bottom-right',
														});
													}
												});
										}}
										className="remove"
										icon={faMinusSquare}
										style={{
											fontSize: 18,
											display: 'none',
											position: 'absolute',
											zIndex: '100',
											marginLeft: 0,
											color: 'red',
											backgroundColor: 'white',
											padding: 2,
											cursor: 'pointer',
										}}
									/>
								)}
								<DownloadAndViewButton marginLeft={0} url={doneFile?.file} size={doneFile?.size} />
							</WrapItem>
						</>
					) : (
						<>
							<Button isDisabled={isPermitted ? false : true} onMouseDown={modal?.onOpen} colorScheme="blue" variant="outline" size="sm">
								{t('Add done file')}
							</Button>
						</>
					)}
				</>
			</Flex>
			{modal?.isOpen && <DoneFileModal npId={npId} onClose={modal?.onClose} onCallback={onCallback} />}
		</>
	);
}

export default DoneFile;
